import {CustomerStateInterface} from '@/store/modules/customer/types';
import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {actions} from '@/store/modules/customer/actions';
import {mutations} from '@/store/modules/customer/mutations';
import {getters} from '@/store/modules/customer/getters';

export const state: CustomerStateInterface = {
    customerDetails: undefined,
};

const namespaced: boolean = true;

export const customerModule: Module<CustomerStateInterface, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
